<div #dialog>
    <mat-card>
        <mat-card-title>
            This feature is only available to Inventory Manager Enterprise users
        </mat-card-title>
        <mat-card-content>
            The Enterprise edition of Inventory Manager includes this and many other great features!
        </mat-card-content>
        <mat-card-actions>
            <button color="primary" mat-flat-button (click)="close(); openEnterpriseDialog()">
                Learn More About Enterprise
            </button>
        </mat-card-actions>
    </mat-card>
</div>
